import React from 'react'
import { useSelector } from 'react-redux'
import { selectAppHomePageValidation } from 'selectors/validation'
import { FeaturedContentSlideData } from 'slices/appLandingPageTheme/types'
import FeaturedContent from './FeaturedContent'

type Props = {
  carouselId: string
  slideId: string
  slide: FeaturedContentSlideData
}

const CarouselSlideContent = ({ carouselId, slideId, slide }: Props) => {
  const imageValidation = useSelector(selectAppHomePageValidation)

  if (!imageValidation) return <></>
  if (slide.type !== 'featured_content') return <></>

  // Convert slide data to the format expected by FeaturedContent
  const contentBlock = {
    ...slide,
    // Ensure the block has the same structure as regular content blocks
    type: 'featured_content' as const,
  }

  // Create the prefix for nested form fields
  const prefix = `${carouselId}.featured_contents`

  return (
    <FeaturedContent
      blockId={slideId}
      contentBlock={contentBlock}
      prefix={prefix}
    />
  )
}

export default CarouselSlideContent
